import { Component, OnInit, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { environment } from "../../../environments/environment";
@Component({
  selector: "app-banner-slider",
  templateUrl: "./banner-slider.component.html",
  styleUrls: ["./banner-slider.component.css"],
})
export class BannerSliderComponent implements OnInit {
  isLoding = true;
  appconstant = environment;
  @Input() data: any;
  @Input() slug: any;

  constructor(public translate: TranslateService) { }
  isContent = false;
  mainslider: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 500,
    dots: true,
    dotsSpeed: true,
    center: true,
    navSpeed: 500,
    slideTransition: "linear",
    mouseDrag: false,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 1,
      },
      575: {
        items: 2.2,
      },
      768: {
        items: 3.2,
      },

      991: {
        items: 4.3,
      },
      1366: {
        items: 4.3,
      },
      1700: {
        items: 4.3,
      },
    },
    nav: true,
  };

  innerslider: OwlOptions = {
    items: 5,
    loop: true,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 500,
    dots: false,
    dotsSpeed: true,
    center: true,
    navSpeed: 500,
    slideTransition: "linear",
    autoWidth: true,
    mouseDrag: false,
    navText: ['<i class="mdi mdi-arrow-left"></i>', '<i class="mdi mdi-arrow-right"></i>'],
    responsive: {
      0: {
        items: 1,
      },
      575: {
        items: 3.2,
      },
      768: {
        items: 2.2
      },
      991: {
        items: 2.2
      },
      1900: {
        items:3.3
      }
    },
    nav: true
  }

  ngOnInit(): void {

    if (this?.data?.featured?.length > 0) {
      this.data.featured.map((data) => {
        if (window.innerWidth < 575) {
          let item = data.thumbnails.findIndex((el) => el.image_type === "landscape");

          if (item != -1) {
            if (data.thumbnails[item].asset) {
              data.thumbnail = data.thumbnails[item].asset;
            } else {
              data.thumbnail = this.appconstant.landscapeDefault;
            }
          } else {
            data.thumbnail = this.appconstant.landscapeDefault;
          }
        } else {
          let item = data.thumbnails.findIndex((el) => el.image_type === "landscape");


          if (item != -1) {
            if (data.thumbnails[item].asset) {
              data.thumbnail = data.thumbnails[item].asset;
            } else {
              data.thumbnail = this.appconstant.landscapeDefault;
            }
          } else {
            data.thumbnail = this.appconstant.landscapeDefault;
          }
        }

      });

    }

  }
}
